const Footer = {
    init() {
        /*
        Marc 6/07 :
        */
        // const accordions = document.querySelectorAll('#main_footer .footer_top .footer_top_right .menu-footer-primary-container > .menu >li .sub-menu li.menu-item-has-children');
        // const accordions = document.querySelectorAll('#menu-footer-primary li.title > a');

        // const accordions = document.querySelectorAll('#menu-footer-primary li > a');

        // for (let i = 0; i < accordions.length; i++) {
        //     accordions[i].addEventListener('click', function(e) {
        //         e.preventDefault();
        //         if (window.matchMedia('(max-width: 1140px)').matches) {
        //             $(this).parent().toggleClass('active');

        //             const lastChild = $(this).parent().find('.sub-menu')[0]; // ul.sub-menu

        //             if (lastChild.style.maxHeight) {
        //                 lastChild.style.maxHeight = null;
        //             } else {
        //                 lastChild.style.maxHeight = lastChild.scrollHeight + 'px';
        //             }
        //         }
        //     });
        // }

        const footer = document.querySelector('#main_footer');

        if (footer) {
            const acc = document.querySelectorAll('#menu-footer-primary li.menu-item > ul.sub-menu > li.menu-item-has-children > a');
            let i;

            for (i = 0; i < acc.length; i++) {
                acc[i].onclick = function(e) {
                    e.preventDefault();
                    // variables
                    const panel = this.nextElementSibling;
                    const listContenuSubmenu = document.querySelectorAll('#menu-footer-primary li.menu-item > ul.sub-menu > li.menu-item-has-children > ul.submenu');
                    const listSubmenuActive = document.querySelectorAll('#menu-footer-primary li.menu-item > ul.sub-menu > li.menu-item-has-children > ul.active');

                    if (panel.style.maxHeight) {
                        // reduit le content deja affiché
                        panel.style.maxHeight = null;
                        panel.style.marginTop = '0px';
                        panel.style.marginBottom = '0px';
                        // supprime la class 'active'
                        panel.classList.remove('active');
                    } else {
                        for (let ii = 0; ii < listSubmenuActive.length; ii++) {
                            listSubmenuActive[ii].classList.remove('active');
                            listSubmenuActive[ii].style.maxHeight = null;
                            listSubmenuActive[ii].style.marginTop = '0px';
                            listSubmenuActive[ii].style.marginBottom = '0px';
                        }
                        
                        //opens the specified pannel
                        panel.style.maxHeight = panel.scrollHeight + 'px';
                        panel.style.marginTop = 11 + 'px';
                        panel.style.marginBottom = 30 + 'px';
                        panel.classList.add('active');
                    }
                };
            }
        }

        // pas de gestion du selecteur de langue sur les pages avec le template simple-page.php
        const body = document.querySelector('body');
        const bodyHasClassSimplePage = body.classList.contains('page-template-simple-page');
        const languageSwitcher = document.querySelector('.js-language-switcher');
        if (!bodyHasClassSimplePage) {
            languageSwitcher.querySelector('li.active a').addEventListener('click', evt => {
                evt.preventDefault();
                languageSwitcher.classList.toggle('open');
            });
        }

        // Obfuscation des liens - gestion du click sur les buttons
        document.querySelectorAll('#main_footer button[data-href]').forEach($link => {
            $link.addEventListener('click', function(evt) {
                if (evt.target.getAttribute('target') === '_blank') {
                    window.open(evt.target.getAttribute('data-href'), '_blank').focus();
                } else {
                    location.href = evt.target.getAttribute('data-href');
                }
            });
        });

        window.onload = function() {
            document.querySelectorAll('button[data-href].button-obfuscated').forEach($link => {
                $link.addEventListener('click', function() {
                    const href = $link.getAttribute('data-href');

                    if ($link.getAttribute('target') === '_blank') {
                        window.open(href, '_blank').focus();
                    } else {
                        location.href = href;
                    }
                });
            });
        };
    },
};

export default Footer;
